"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildTabFacets = buildTabFacets;
exports.buildTabFacetsRequests = buildTabFacetsRequests;
exports.getZendeskLocaleBySearchState = getZendeskLocaleBySearchState;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _constants = require("../../constants");

var _SearchService = _interopRequireDefault(require("@insided/destination/modules/Search/services/SearchService"));

var _search = require("@insided/destination/modules/Search/utils/search");

var _filtersBuilder = require("../../utils/filters-builder");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var communityId = (0, _search.getCommunityId)();
/**
 *
 * @param query
 * @description Prepare "requests" to get facets data i.e., content_type and external source (just apply search query and not any facets/filters)
 * @reason If we apply any filters, algolia by default returns facets based on filtered data (so you wont see facets that doesnt have data after applying filters)
 * But in our case, we are building custom tabs and we want to show all the facets irrespective of the filters (sidebar filters) applied
 */

function buildTabFacetsRequests(query) {
  var _heroFilters$searchIn, _heroFilters$searchIn2, _heroFilters$searchIn3, _heroFilters$searchIn4;

  var _allowedIndexes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var includedDataSource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var hiddenCategories = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var activeNonSourceFacetFilters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var heroFilters = arguments.length > 5 ? arguments[5] : undefined;
  var restrictSearchableAttributes = (0, _search.getRestrictedSearchableAttributes)(); // OR-joined `forum:X` / `product_area:X` clauses from the hero pre-filters
  // — same shape as the main results query's filter, so the tab counts
  // narrow to the same population. Without this, tabs over-report relative
  // to the actual displayed result set (e.g. 18 results shown, 200 in the
  // Community tab badge).

  var heroFilterOperands = [].concat((0, _toConsumableArray2.default)((_heroFilters$searchIn = heroFilters === null || heroFilters === void 0 ? void 0 : (_heroFilters$searchIn2 = heroFilters.searchInContentCategories) === null || _heroFilters$searchIn2 === void 0 ? void 0 : _heroFilters$searchIn2.map(function (value) {
    return {
      key: 'forum',
      value: value
    };
  })) !== null && _heroFilters$searchIn !== void 0 ? _heroFilters$searchIn : []), (0, _toConsumableArray2.default)((_heroFilters$searchIn3 = heroFilters === null || heroFilters === void 0 ? void 0 : (_heroFilters$searchIn4 = heroFilters.searchInProductAreas) === null || _heroFilters$searchIn4 === void 0 ? void 0 : _heroFilters$searchIn4.map(function (value) {
    return {
      key: 'product_area',
      value: value
    };
  })) !== null && _heroFilters$searchIn3 !== void 0 ? _heroFilters$searchIn3 : []));
  var heroFilterGroup = heroFilterOperands.length > 0 ? [{
    operator: 'OR',
    operands: heroFilterOperands
  }] : [];
  return [// 1 request to get community sources (actually count of all the sources)
  {
    indexName: communityId,
    query: query !== null && query !== void 0 ? query : '',
    params: _objectSpread({
      hitsPerPage: 0,
      facets: ['gs_data_source'],
      query: query,
      facetingAfterDistinct: true,
      restrictSearchableAttributes: restrictSearchableAttributes,
      analytics: false,
      // Exclude from search analytics to avoid inflating Total Searches count
      filters: (0, _filtersBuilder.stringifyFilterExpression)({
        operator: 'AND',
        operands: [{
          key: 'gs_data_source',
          value: 'community'
        }, {
          operator: 'AND',
          operands: hiddenCategories.map(function (value) {
            return {
              operator: 'NOT',
              operand: {
                key: 'forum',
                value: value
              }
            };
          }),
          noParentheses: true // because algolia doesnt support (A AND B) AND C. We need to do A AND B AND C

        }].concat(heroFilterGroup)
      })
    }, activeNonSourceFacetFilters.length > 0 ? {
      facetFilters: activeNonSourceFacetFilters
    } : {})
  }, // 1 request to get all the sources from external gs_data_source
  {
    indexName: communityId,
    query: query !== null && query !== void 0 ? query : '',
    params: _objectSpread({
      hitsPerPage: 0,
      facets: ['source'],
      query: query,
      facetingAfterDistinct: true,
      restrictSearchableAttributes: restrictSearchableAttributes,
      analytics: false,
      // Exclude from search analytics to avoid inflating Total Searches count
      filters: (0, _filtersBuilder.stringifyFilterExpression)({
        operator: 'AND',
        operands: [{
          operator: 'OR',
          operands: includedDataSource.map(function (item) {
            return {
              key: 'gs_data_source',
              value: item
            };
          })
        }, {
          operator: 'AND',
          operands: hiddenCategories.map(function (value) {
            return {
              operator: 'NOT',
              operand: {
                key: 'forum',
                value: value
              }
            };
          }),
          noParentheses: true // because algolia doesnt support (A AND B) AND C. We need to do A AND B AND C

        }].concat(heroFilterGroup)
      })
    }, activeNonSourceFacetFilters.length > 0 ? {
      facetFilters: activeNonSourceFacetFilters
    } : {})
  }];
}
/**
 *
 * @description Extract tabFacets data from the algolia response and set it in the searchService
 */


function buildTabFacets(_ref) {
  var _communityResponse$fa, _communityResponse$fa2, _communityResponse$fa3, _externalSourcesRespo, _externalSourcesRespo2;

  var tabFacetsResponse = _ref.tabFacetsResponse,
      selectedSource = _ref.selectedSource,
      _selectedContentType = _ref._selectedContentType,
      selectedGsDataSource = _ref.selectedGsDataSource;
  var tabFacets = [];
  var communityResponse = tabFacetsResponse[0];
  var communitySourcesCount = (_communityResponse$fa = communityResponse === null || communityResponse === void 0 ? void 0 : (_communityResponse$fa2 = communityResponse.facets) === null || _communityResponse$fa2 === void 0 ? void 0 : (_communityResponse$fa3 = _communityResponse$fa2.gs_data_source) === null || _communityResponse$fa3 === void 0 ? void 0 : _communityResponse$fa3.community) !== null && _communityResponse$fa !== void 0 ? _communityResponse$fa : 0;
  var externalSourcesResponse = tabFacetsResponse[1];
  var externalSources = (_externalSourcesRespo = externalSourcesResponse === null || externalSourcesResponse === void 0 ? void 0 : (_externalSourcesRespo2 = externalSourcesResponse.facets) === null || _externalSourcesRespo2 === void 0 ? void 0 : _externalSourcesRespo2.source) !== null && _externalSourcesRespo !== void 0 ? _externalSourcesRespo : {};
  tabFacets.push({
    count: communitySourcesCount,
    isRefined: selectedGsDataSource === 'community',
    label: 'community',
    type: 'gs_data_source',
    id: generateRandomID()
  });
  Object.keys(externalSources) // only show tabs for external sources.
  // This filter is not needed if we have external sources available,
  // in that case it will prepare the query (in buildTabFacetsRequests) to include only external sources
  // But when we don't have external sources (empty []), the filter becomes empty which fetches data for all sources (including internal in this case)
  .filter(function (item) {
    return !['community', 'knowledge_base'].includes(item);
  }).forEach(function (source) {
    return tabFacets.push({
      count: externalSources[source],
      isRefined: source === selectedSource,
      label: source,
      type: 'source',
      id: generateRandomID()
    });
  });
  var selectedTab = selectedGsDataSource || selectedSource; // If there are no results, then add "selected tab" manually (to show the no results screen inside it)

  if (selectedTab && !tabFacets.some(function (item) {
    return item.isRefined;
  })) {
    var selectedTabType = selectedSource ? 'source' : 'content_type';
    tabFacets.push({
      count: 0,
      isRefined: true,
      label: selectedTab,
      type: selectedTabType,
      id: generateRandomID()
    });
  }

  _SearchService.default.tabFacets = (0, _search.sortArrayBySortOrder)({
    data: tabFacets,
    key: 'label',
    sortOrder: _constants.SOURCE_SORT_ORDER
  });
}

function generateRandomID() {
  return "".concat(Math.random().toString(36).substring(2, 10), "-").concat(Math.random().toString(36).substring(2, 10));
}

function getZendeskLocaleBySearchState(state) {
  var _state$indices, _state$indices$, _state$indices$$refin;

  return (_state$indices = state.indices) === null || _state$indices === void 0 ? void 0 : (_state$indices$ = _state$indices["".concat(communityId, "-zendesk")]) === null || _state$indices$ === void 0 ? void 0 : (_state$indices$$refin = _state$indices$.refinementList) === null || _state$indices$$refin === void 0 ? void 0 : _state$indices$$refin.locale;
}